module.exports = __webpack_public_path__ + "img/mypage08.520a7827.png";